export default __webpack_public_path__ + "static/media/no-results.91392800.svg";